import React from 'react'
import { useTranslation } from 'react-i18next'
import SettingsLabelText from '../../UI/SettingsLabelText'
import LangSelector from '../../LangSelector/LangSelector'
import InputWrapper from '../../Formik/InputWrapper'
import UpdatePolicy from '../../Forms/UpdatePolicy'
import { useAuthContext } from '../../../context/auth/auth'

const General = () => {
  const { t } = useTranslation()
  const { authClient } = useAuthContext()
  // The super admin settings screen shows the privacy policy field too (S6).
  const canEditPrivacyPolicy =
    authClient?.user_type === 'ADMINISTRATOR' ||
    authClient?.user_type === 'SUPER_ADMINISTRATOR'
  return (
    <div>
      <h2 className='font-bold text-2xl text-[#3D3D3D]'>{t('general')}</h2>
      <div className='grid sm:grid-cols-2 gap-5 sm:gap-10 mt-8'>
        <div>
          <SettingsLabelText text={t('language')} />
          <LangSelector type='admin' />
        </div>
        {canEditPrivacyPolicy && (
          <InputWrapper>
            <SettingsLabelText text={t('updatePrivacyPolicy')} />
            <UpdatePolicy />
          </InputWrapper>
        )}
      </div>
    </div>
  )
}

export default General
